<template>
    <div
        v-spinner="loading"
        class="priv-detail-box"
    >
        <v-spinner
            :opacity="0.5"
            :offset-y="150"
            size="large"
        />
        <v-tip
            ref="privTip"
            placement="top"
            clazz="priv-tip"
        >
            <template slot-scope="props">
                <span>{{ props.data }}</span>
            </template>
        </v-tip>
        <v-tabs
            v-model="currTab"
            v-show="!loading"
        >
            <v-tab value="feature">
                功能权限
            </v-tab>
            <v-tab
                v-show="dataPrivArr.length > 0"
                value="data"
            >
                数据权限
            </v-tab>
        </v-tabs>
        <div
            v-show="!loading"
            class="priv-detail-wrap"
        >
            <div
                v-show="showFeaturePriv"
                class="priv-detail-feature"
            >
                <div
                    v-for="fItem in featurePrivArr"
                    :key="fItem.id"
                    class="priv-detail-feature-item"
                >
                    <div
                        @click="expandPriv(fItem)"
                        class="priv-detail-feature-tit"
                    >
                        <span> {{ fItem.name }} ({{ fItem.num }})</span>
                        <v-icon
                            :flip="fItem.expand ? 'vertical' : ''"
                            class="moreicon"
                            name="arrowdown"
                        />
                    </div>
                    <ul v-if="fItem.expand">
                        <li
                            v-for="subFItem in fItem.subArr"
                            :key="subFItem.id"
                        >
                            {{ subFItem.name }}
                            <v-icon
                                v-tip:privTip.hover.delay="subFItem.alertTip"
                                v-if="subFItem.alertTip"
                                name="v-error"
                                class="priv-detail-alert-icon"
                            />
                        </li>
                    </ul>
                </div>
            </div>
            <div
                v-show="showDataPriv"
                class="priv-deatil-data-list"
            >
                <div
                    v-for="dItem in dataPrivArr"
                    :key="dItem.id"
                    class="priv-detail-data-item"
                >
                    <div class="priv-detail-data-tit">
                        <span>{{ dItem.name }}</span>
                    </div>
                    <div
                        v-for="subDItem in dItem.setArr"
                        :key="subDItem.id"
                        class="priv-detail-data-set"
                    >
                        <div class="priv-detail-data-label">
                            {{ subDItem.name }}
                        </div>
                        <div class="priv-detail-data-desc">
                            <p
                                v-for="(oName, oIndex) in subDItem.optArr"
                                :key="'opt' + oIndex"
                            >
                                {{ oName }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Icon } from 'vhtml-ui';

const req = require.context('./assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);

export default {
    components: {},
    props: {
        roleId: {
            type: [Number, String],
            default: -1,
        },
    },
    data() {
        return {
            loading: true,
            currTab: 'feature',
            featurePrivArr: [],
            dataPrivArr: [],
            checkedPrivItem: [],
            alertTips: {
                'terminal-external': '关闭此权限将无法与外部联系人/客户沟通，请慎重选择',
                'reception-corp-auto-response': '关闭此权限将无法接待主号通路的客户',
                'sale-crm': '关闭此权限将无法进行客户接待，请慎重选择',
                'terminal-transfer': '此配置仅支持2.1以上版本的客户端',
                'manage-report': '同时勾选管理>客户管理配置可查看全公司员工分析报表',
                'manager-attendant-report': '请在“办公考勤-考勤设置”设定报表查看范围',
                'tickets-lists': '该权限控制账户中心工单列表和客户端顶部工单入口',
                'terminal-tickets': '需要拥有 “工单管理-工单列表” 权限',
                'tickets-schedule-setting': '需要有工单处理组权限',
                forbidden_corpuin_add_friend: '此配置仅支持3.5及以上版本',
                forbidden_uin_add_friend: '此配置仅支持3.5及以上版本',
            },
        };
    },

    computed: {
        showFeaturePriv() {
            return this.currTab === 'feature';
        },

        showDataPriv() {
            return this.currTab === 'data';
        },

        // 已勾选的非端权限位id数组
        checkedPrivIdArr() {
            const checkedIdArr = [];
            this.checkedPrivItem.forEach((item) => {
                if (item.FType !== 1) {
                    checkedIdArr.push(parseInt(item.id, 10));
                }
            });

            // 数组去重
            return Array.from(new Set(checkedIdArr));
        },

        // 已勾选的端权限位id数组
        checkedTerminalPrivIdArr() {
            const checkedIdArr = [];
            this.checkedPrivItem.forEach((item) => {
                if (item.FType === 1) {
                    checkedIdArr.push(parseInt(item.id, 10));
                }
            });

            // 数组去重
            return Array.from(new Set(checkedIdArr));
        },
    },

    created() {
        this.getPrivData();
    },

    methods: {
        getPrivData() {
            this.loading = true;
            this.$ajax
                .read('/mng/role/GetPrivilegesList', {
                    roleId: this.roleId,
                })
                .then(
                    (res) => {
                        const r = res || {};
                        this.featurePrivOri = r.privileges || {};
                        this.dataPrivOri = r.data_privileges || {};
                        this.formatFeaturePrivData();
                        this.formatDataPrivData();
                        this.loading = false;
                        this.$emit('init', r);
                    },
                    (error) => {
                        this.$message.error((error && error.message) || '加载失败，请稍后重试');
                        this.loading = false;
                    }
                );
        },

        formatFeaturePrivData() {
            const featureCheckedArr = [];
            let checkedPrivItem = [];

            Object.keys(this.featurePrivOri).forEach((k) => {
                const fItem = this.featurePrivOri[k];
                const subArr = [];

                if (fItem && fItem.items) {
                    Object.keys(fItem.items).forEach((sk) => {
                        const subItem = fItem.items[sk];
                        if (parseInt(subItem.checked, 10) === 1) {
                            subArr.push({
                                id: sk,
                                name: this.getComboPrivName(subItem),
                                alertTip: this.alertTips[sk],
                            });
                            checkedPrivItem = checkedPrivItem.concat(subItem.list);
                        }
                    });
                }

                if (subArr.length > 0) {
                    featureCheckedArr.push({
                        id: k,
                        name: fItem.name,
                        num: subArr.length,
                        expand: false,
                        subArr,
                    });
                }
            });

            // if (featureCheckedArr.length > 0) {
            //     featureCheckedArr[0].expand = true;
            // }

            this.featurePrivArr = featureCheckedArr;
            this.checkedPrivItem = checkedPrivItem;
        },

        formatDataPrivData() {
            const dataPrivArr = [];

            Object.keys(this.dataPrivOri).forEach((k) => {
                const item = this.dataPrivOri[k];
                const fItem = this.featurePrivOri[k];
                const setArr = [];

                item.forEach((sItem) => {
                    // 选项数据
                    const optArr = this.getCombineOpts(sItem);
                    if (optArr.length > 0 && this.isCheckFeaturePriv(sItem.pris)) {
                        setArr.push({
                            id: sItem.bo_id,
                            name: sItem.name,
                            optArr,
                        });
                    }
                });

                if (setArr.length > 0) {
                    dataPrivArr.push({
                        id: k,
                        name: fItem && fItem.name,
                        setArr,
                    });
                }
            });

            this.dataPrivArr = dataPrivArr;
        },

        // 是否勾选了对应的功能权限，勾选了功能权限数据权限才生效
        isCheckFeaturePriv(privs, terminalPrivs) {
            let isChecked = false;

            if (privs && privs.length > 0) {
                privs.every((id) => {
                    if (this.checkedPrivIdArr.includes(parseInt(id, 10))) {
                        isChecked = true;
                        return false;
                    }
                    return true;
                });
            }

            if (terminalPrivs && terminalPrivs.length > 0) {
                terminalPrivs.every((id) => {
                    if (this.checkedTerminalPrivIdArr.includes(parseInt(id, 10))) {
                        isChecked = true;
                        return false;
                    }
                    return true;
                });
            }

            return isChecked;
        },

        getComboPrivName(subItem) {
            const { list } = subItem || {};

            return list.map(item => item.name).join('/');
        },

        // meta数据组合成下拉选项数据展示
        getCombineOpts(item) {
            const { metas } = item || {};
            const combineArr = [];

            // 选项数据
            const optArr = metas.filter(mItem => parseInt(mItem.type, 10) === 1);

            // 操作类型数据
            const operateArr = metas.filter(mItem => parseInt(mItem.type, 10) === 2);

            operateArr.forEach((operateItem) => {
                const options = [];
                const currValSet = operateItem.scope || [];

                optArr.forEach((optItem) => {
                    if (currValSet.includes(optItem.name)) {
                        options.push(optItem.description);
                    }
                });

                combineArr.push(`${operateItem.description}：${options.join(', ')}`);
            });

            return combineArr;
        },

        expandPriv(item) {
            item.expand = !item.expand;
            this.$emit('expand', item);
        },

        refresh() {
            this.getPrivData();
        },
    },
};
</script>

<style lang="less">
@import './index.less';
</style>
